import { OlkyPassRoutes } from "@/utils/routes";

export const Routes = {
  ...[] /* OlkypayRoutes */,
  ...OlkyPassRoutes
};
